import React, { useState } from "react";


const RecruiterOnboarding = ({ userId = "" }) => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        name: "",
        companyName: "",
        email: "",
        companyWebsite: "",
        contactNumber: "",
        position: "",
        terms: false,
        resumeZip: null,
        jdZip: null,
        userId: userId
    });
    const [error, setError] = useState("");

    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked :
                type === "file" ? files[0] :
                    value
        }));
    };

    const validateStep = (currentStep) => {
        setError("");
        if (currentStep === 1) {
            if (!formData.name || !formData.companyName || !formData.email ||
                !formData.companyWebsite || !formData.contactNumber || !formData.position) {
                setError("Please fill in all fields");
                return false;
            }
            if (!formData.terms) {
                setError("Please accept the terms and conditions");
                return false;
            }
        } else if (currentStep === 2) {
            // if (!formData.resumeZip || !formData.jdZip) {
            //     setError("Please upload both resume and job description files");
            //     return false;
            // }
        }
        return true;
    };

    const handleNextStep = () => {
        if (validateStep(step)) {
            setStep(step + 1);
        }
    };

    const handlePreviousStep = () => {
        setStep(step - 1);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateStep(step)) return;

        const submitData = new FormData();
        // Append all form data
        Object.keys(formData).forEach(key => {
            submitData.append(key, formData[key]);
        });
        submitData.append("userId", userId);

        try {
            const response = await fetch('/api/recruiterOnboarding', {
                method: 'POST',
                body: submitData
            });

            if (!response.ok) throw new Error('Submission failed');
            const message = 'Signed up successfully.';
            const encodedMessage = btoa(message);
            await new Promise(resolve => setTimeout(resolve, 1000));
            window.location.href = '/?message=' + encodeURIComponent(encodedMessage);
        } catch (error) {
            setError('An error occurred. Please try again.');
            console.error('Error:', error);
        }
    };

    return (
        <div className="container mx-auto p-4 flex justify-center items-center min-h-screen">
            <div className="w-full max-w-lg bg-white shadow-md rounded-lg p-6">
                <h1 className="text-2xl mb-4 text-center">Recruiter Onboarding</h1>
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        {error}
                    </div>
                )}
                <form onSubmit={handleSubmit} className="space-y-4">
                    {step === 1 && (
                        <>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    placeholder="Enter your name"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Company Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="companyName"
                                    type="text"
                                    value={formData.companyName}
                                    onChange={handleInputChange}
                                    placeholder="Enter your company name"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Email Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Enter your email address"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Company Website
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="companyWebsite"
                                    type="url"
                                    value={formData.companyWebsite}
                                    onChange={handleInputChange}
                                    placeholder="Enter your company website"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Contact Number
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="contactNumber"
                                    type="tel"
                                    value={formData.contactNumber}
                                    onChange={handleInputChange}
                                    placeholder="Enter your contact number"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Position
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="position"
                                    type="text"
                                    value={formData.position}
                                    onChange={handleInputChange}
                                    placeholder="Enter your position"
                                />
                            </div>
                            <div className="flex items-center">
                                <input
                                    className="mr-2 leading-tight"
                                    type="checkbox"
                                    name="terms"
                                    checked={formData.terms}
                                    onChange={handleInputChange}
                                />
                                <label className="text-sm">
                                    I agree to the <a href="/terms" className="text-blue-500">terms and conditions</a> and <a href="/privacy" className="text-blue-500">privacy policy</a>
                                </label>
                            </div>
                        </>
                    )}
                    {step === 2 && (
                        <>
                            <div>
                                < h2 className="text-xl font-semibold mb-2">Upload Catalogue</h2>
                                <p className="text-gray-700"> Upload your existing resumes and job descriptions to index them, allowing you to easily match candidates to new job openings and vice versa. </p>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Upload Resumes (ZIP)
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="resumeZip"
                                    type="file"
                                    onChange={handleInputChange}
                                    accept=".zip"
                                />
                            </div>
                            <div>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Upload Job Descriptions (ZIP)
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="jdZip"
                                    type="file"
                                    onChange={handleInputChange}
                                    accept=".zip"
                                />
                            </div>
                        </>
                    )}
                    {step === 3 && (
                        <div className="text-center">
                            <p className="text-lg">Thank you for submitting your information.</p>
                            <p className="text-lg">We are redirecting you to the home page.</p>
                        </div>
                    )}
                    <div className="flex items-center justify-between">
                        {step > 1 && (
                            <button
                                type="button"
                                onClick={handlePreviousStep}
                                className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            >
                                Previous
                            </button>
                        )}
                        {step < 3 ? (
                            <button
                                type="button"
                                onClick={handleNextStep}
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            >
                                Next
                            </button>
                        ) : (
                            <button
                                type="submit"
                                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                            >
                                Submit
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RecruiterOnboarding;